module.exports = __webpack_public_path__ + "img/ide-judge.4838442f.svg";